import type { ShopifyLifecycleState } from '@discovr/types';
import { shopifyCopy } from './shopify';

export function lifecycleText(lifecycle: ShopifyLifecycleState, shopDomain?: string): string | null {
  const copy = shopifyCopy.lifecycle;
  switch (lifecycle) {
    case 'uninstalling':
      return shopDomain ? copy.uninstalling(shopDomain) : copy.uninstallingNoShop;
    case 'access_lost':
      return copy.access_lost;
    case 'deleting':
      return copy.deleting;
    case 'removed':
      return copy.removed;
    default:
      return null;
  }
}
